import { render, staticRenderFns } from "./EventThumbnail.vue?vue&type=template&id=470a224d&scoped=true&"
import script from "./EventThumbnail.vue?vue&type=script&lang=js&"
export * from "./EventThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./EventThumbnail.vue?vue&type=style&index=0&id=470a224d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a224d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCarousel,VCarouselItem,VImg,VRow,VSheet,VSlideGroup,VSlideItem})
